import Button from './Button'
import { useCopy } from '../hooks/useCopy'

interface CopyButtonProps {
    value: string
    label?: string
    copiedLabel?: string
}

/**
 * A real button, not a clickable table cell -- the old UI put onClick on <td>,
 * which keyboard users could not reach at all. Success is announced through a
 * live region so it is not a purely visual confirmation.
 */
export default function CopyButton({ value, label = 'Copy', copiedLabel = 'Copied' }: CopyButtonProps) {
    const { copied, copy } = useCopy()

    return (
        <>
            <Button onClick={() => copy(value)} aria-label={`${label} ${value}`}>
                {copied ? copiedLabel : label}
            </Button>
            <span role="status" aria-live="polite" className="visually-hidden">
                {copied ? `${copiedLabel}: ${value}` : ''}
            </span>
        </>
    )
}
